import { InjectionToken } from '@angular/core';
import { API_DOC_LANGS_MAP } from '@bazis/configuration.service';

export const API_DOC_LANGS = new InjectionToken<Record<string, string>>('API_DOC_LANGS', {
    providedIn: 'root',
    factory: () => API_DOC_LANGS_MAP,
});
